<template>
    <v-container fill-height>
            <v-card class="mx-auto" min-width="100%" height="100%" >
                <v-card-title class="headline"></v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-card-text>

                    <!--<v-row justify="center" class="display-2">パスワード変更</v-row>-->
                    <v-row class="text-center" justify="center">
                        <v-form v-model="valid" ref="form" lazy-validation>
                            <v-alert v-if="message != ''"
                                     color="blue"
                                     text>{{this.message}}</v-alert>
                            <v-alert v-if="error != ''"
                                     color="red"
                                     text>{{this.error}}</v-alert>
                            <v-col cols="50">
                                <v-text-field label="現在のパスワード"
                                              v-model="oldPassword"
                                              :counter="20"
                                              :rules="[GlobalRules.required,
                                        GlobalRules.hanSpec,
                                        GlobalRules.more_8,
                                        GlobalRules.required_lowercase,
                                        GlobalRules.required_uppercase,
                                        GlobalRules.required_number,
                                        GlobalRules.required_spec]"
                                              required
                                              v-bind:type="showOldPassword ? 'text':'password'"
                                              v-bind:append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                              prepend-icon="mdi-lock"
                                              @click:append="showOldPassword=!showOldPassword"></v-text-field>
                            </v-col>
                            <v-col cols="50">
                                <v-text-field label="新しいパスワード"
                                              v-model="newPassword"
                                              :counter="20"
                                              :rules="[GlobalRules.required,
                                        GlobalRules.hanSpec,
                                        GlobalRules.more_8,
                                        GlobalRules.required_lowercase,
                                        GlobalRules.required_uppercase,
                                        GlobalRules.required_number,
                                        GlobalRules.required_spec]"
                                              required
                                              v-bind:type="showNewPassword ? 'text':'password'"
                                              v-bind:append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                              prepend-icon="mdi-lock"
                                              @click:append="showNewPassword=!showNewPassword"></v-text-field>
                            </v-col>
                            <v-col cols="50">
                                <v-text-field label="もう一度入力"
                                              v-model="confPassword"
                                              :counter="20"
                                              :rules="[GlobalRules.required,
                                        GlobalRules.hanSpec,
                                        GlobalRules.more_8,
                                        GlobalRules.required_lowercase,
                                        GlobalRules.required_uppercase,
                                        GlobalRules.required_number,
                                        GlobalRules.required_spec]"
                                              required
                                              v-bind:type="showConfPassword ? 'text':'password'"
                                              v-bind:append-icon="showConfPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                              prepend-icon="mdi-lock"
                                              @click:append="showConfPassword=!showConfPassword"></v-text-field>
                            </v-col>
                            <v-card-actions>
                                <v-btn color="blue"
                                       outlined
                                       block
                                       :disabled="!valid"
                                       @click="changePass(oldPassword,newPassword)">変更</v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-row>

                </v-card-text>
            </v-card>
    </v-container>
</template>

<script>
    export default {       
        name: 'ChangePass',
        data: () => ({
            showOldPassword: false,
            showNewPassword: false,
            showConfPassword: false,
            valid: false,
            error: "",
            message: "",
            newPassword: "",
            confPassword: "",
            oldPassword: "",
        }),

        methods: {
            changePass(oldPassword, newPassword) {
                if (newPassword == this.confPassword) {
                    this.$cognito.updatePassword(oldPassword, newPassword)
                        .then(result => {
                            console.log("成功")
                            //console.log({ result })
                            this.message = "パスワードを変更しました。"
                            this.error = ""
                        })
                        .catch(err => {
                            console.log(err)
                            this.error = "変更できませんでした。入力内容を確認してください。"
                            this.message = ""
                        })
                } else {
                    this.error = 'パスワードの入力内容を確認してください。'
                    this.message = ""
                }
            },


        }
    }</script>

